import {exeRequest} from '../utils/APIUtils'

export default {
    // DATA
    getSites : async  () => exeRequest(`/list/site`, "GET"),
}